module.exports = __webpack_public_path__ + "static/media/icon-orange-desktop.0857f40d.svg";